import React from "react";

import { Box } from "@origin-digital/ods-core";

/**
 * This component renders children invisibly on the page, the reason
 * behind this is that if SVG's are rendered hidden initially (first render),
 * e.g. by using the <Hidden /> component or setting the display property
 * to "none" the definitions for the SVG won't be available to the subsequent
 * uses.
 */
export const PreRender: React.FC = ({ children }) => (
  <Box
    style={{
      pointerEvents: "none",
      position: "absolute",
      left: "-9999px",
      opacity: 0,
    }}
  >
    {children}
  </Box>
);
